/* eslint-disable import/order */
import { Table } from 'antd'
import React, { useEffect, useState } from 'react';
import './datatable.css';
import PropTypes from 'prop-types';
import TitleOfCol from './TitleOfCol';

const METHOD_LABELS = {
    bayes: 'FIDBv2¹',
    clasico1: 'FIDBv2.5²',
    clasico2: 'FIDBv3³'
};

const Datatable = ({ data }) => {
    const [dataProcesed, setDataProcesed] = useState([]);

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {
            // data es ahora un array de resultados, uno por método
            setDataProcesed((prevEstate) => [
                ...prevEstate,
                ...data.map((row, idx) => ({ ...row, key: prevEstate.length + idx }))
            ]);
        }
    }, [data]);

    const columns = [
        {
            title: <TitleOfCol colTitle='Metodo' align="left" />,
            dataIndex: 'method',
            key: 'method',
            width: '80px',
            fixed: 'left',
            render: (value) => (
                <p style={{ 
                    fontSize: '12px',
                    margin: '0',
                    wordBreak: 'normal',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                    lineHeight: '1.2',
                    minHeight: 'fit-content'
                }}>
                    {METHOD_LABELS[value] || value}
                </p>
            )
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.country' align="left" />,
            dataIndex: 'country',
            key: 'country',
            width: '100px',
            fixed: 'left'
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.city' align="left" />,
            dataIndex: 'city',
            key: 'city',
            width: '100px',
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.institution' align="left" />,
            dataIndex: 'institution',
            key: 'institution',
            width: '100px',
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.origin' align="left" />,
            dataIndex: 'origin',
            key: 'origin',
            width: '80px',
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.chronology' align="left" />,
            dataIndex: 'chronology',
            key: 'chronology',
            width: '80px',
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.code' align="left" />,
            dataIndex: 'code',
            key: 'code',
            width: '60px',
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.sex' align="left" />,
            dataIndex: 'sex',
            key: 'sex',
            width: '50px'
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.type' align="left" />,
            dataIndex: 'type',
            key: 'type',
            width: '80px',
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.rl' align="left" />,
            dataIndex: 'rl',
            key: 'rl',
            width: '40px'
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.pr' align="left" />,
            dataIndex: 'pr',
            key: 'pr',
            width: '40px'
        },
        {
            title: <TitleOfCol colTitle='description.contextInfo.rdt' align="left" />,
            dataIndex: 'rdt',
            key: 'rdt', 
            width: '40px'
        },
        {
            title: <TitleOfCol colTitle='description.tableResults.estAge' align="left" />,
            dataIndex: 'estimate_age',
            key: 'estimate_age',
            width: '5em',
            fixed: 'right'
        },
        {
            title: <TitleOfCol colTitle='description.tableResults.LIm' align="left" />,
            dataIndex: 'lli',
            key: 'lli',
            fixed: 'right',
            width: '60px'
        },
        {
            title: <TitleOfCol colTitle='description.tableResults.LSm' align="left" />,
            dataIndex: 'uli',
            key: 'uli',
            fixed: 'right',
            width: '60px'
        },
        {
            title: <TitleOfCol colTitle='description.tableResults.estCorrAge' align="left" />,
            dataIndex: 'c_estimate_age',
            key: 'c_estimate_age',
            fixed: 'right',
            width: '100px'
        },
        {
            title: <TitleOfCol colTitle='description.tableResults.LIm' align="left" />,
            dataIndex: 'llci',
            key: 'llci',
            fixed: 'right',             
            width: '60px'
        },
        {
            title: <TitleOfCol colTitle='description.tableResults.LSm' align="left" />,
            dataIndex: 'ulci',
            key: 'ulci',
            fixed: 'right',
            width: '60px'
        },
    ];
    return (
        <div style={{ width: '100%' }}>
            <Table 
                style={{ fontSize: '12px' }} 
                rowKey={record => record.key} 
                dataSource={dataProcesed} 
                columns={columns} 
                bordered 
                size="small" 
                scroll={{ y: '40vh', x: '100%' }} 
                pagination={false} 
            />
        </div>
    );
};

export default Datatable

// eslint-disable-next-line react/forbid-prop-types
Datatable.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    data: PropTypes.arrayOf(PropTypes.object).isRequired
};